<template>
  <el-select
    :loading="loading"
    :value="selected"
    :placeholder="placeholderI18n"
    :disabled="disabled"
    @change="updateOffice"
  >
    <el-option v-for="office in offices" :key="office.name" :label="office.name" :value="office.id">
    </el-option>
  </el-select>
</template>
<script>
import { mapState } from 'vuex';
import { DEFAULT_OFFICE } from '@/constants';

export default {
  name: 'OfficeDropdown',
  props: {
    selected: {
      type: Number,
      default: DEFAULT_OFFICE,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$emit('change', this.selected);
  },
  computed: {
    ...mapState('offices', { offices: (state) => state.offices }),
    loading() {
      return !this.offices.length;
    },
    placeholderI18n() {
      return this.$t('settings.dropDownPlaceholder');
    },
  },
  methods: {
    updateOffice(office) {
      this.$emit('change', office);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';

.el-select-dropdown {
  &__item {
    font-family: 'Avenir';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OfficeDropdown.vue